import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const store = new Vuex.Store({
    state:{//用来存储数据
        // language:localStorage.getItem('lang')|| 'en'
        EnZh:localStorage.getItem('lang')=='zh'?false:true,//真en，假zh 默认英文
        sectionId:''
    },  
    mutations:{//用来改变state里面的数据

    }
})
export default store